import { render, staticRenderFns } from "./cardDialog.vue?vue&type=template&id=60f6405d&scoped=true&"
import script from "./cardDialog.vue?vue&type=script&lang=js&"
export * from "./cardDialog.vue?vue&type=script&lang=js&"
import style0 from "./cardDialog.vue?vue&type=style&index=0&id=60f6405d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6405d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f6405d')) {
      api.createRecord('60f6405d', component.options)
    } else {
      api.reload('60f6405d', component.options)
    }
    module.hot.accept("./cardDialog.vue?vue&type=template&id=60f6405d&scoped=true&", function () {
      api.rerender('60f6405d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/insurance/cardDialog.vue"
export default component.exports